import React from 'react';
import { IncomeDetailsSection, SecondaryIncomeDetailsSection } from '../../Sections/IncomeDetails';

const IncomeDetailsSectionPicker = ({ clientResource, ...rest }) => {
  const isClientPrimary = clientResource.attr('isPrimary') === 'true';
  const DefaultComponent = isClientPrimary ? IncomeDetailsSection : SecondaryIncomeDetailsSection;

  return <DefaultComponent clientResource={clientResource} {...rest} />;
};

export default IncomeDetailsSectionPicker;
